import { Section } from "@/components/Global/Section/Section";
import { RecipeCard } from "@/components/RecipeCard/RecipeCard";
import { generateRecipeImages } from "@/components/RecipeComponents/RecipeSingleView/RecipeImage/RecipeImage";
import { useAppContext } from "@/context/AppContext";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React, { useEffect } from "react";
import styles from "./Favorite.module.scss";
import { Button } from "@/components/Global/Button/Button";
import { Loader } from "@/components/Loader/Loader";

function Favorite() {
  const { recipeFav, loading } = useAppContext();
  const { getLabel } = useGlobalContext();
  const { rezepte_count, rezepte_list } = recipeFav || {};
  const posts_per_page = 6;
  const [recipesToShow, setRecipesToShow] = React.useState(
    rezepte_list?.slice(0, posts_per_page) || [],
  );
  useEffect(() => {
    setRecipesToShow(rezepte_list?.slice(0, posts_per_page) || []);
  }, [rezepte_list]);
  const handleLoadMore = () => {
    if (rezepte_list && recipesToShow.length < rezepte_list.length) {
      const newRecipes = rezepte_list.slice(
        recipesToShow.length,
        recipesToShow.length + posts_per_page,
      );
      setRecipesToShow((prev) => [...prev, ...newRecipes]);
    }
  };
  return (
    <Section disableColumns className={styles["favorite-recipes"]}>
      <p aria-live="polite">
        {rezepte_count ? rezepte_count : 0} {getLabel("recipe")}
      </p>
      {recipesToShow && recipesToShow.length > 0 ? (
        <>
          <ul className="columns is-multiline">
            {recipesToShow.map((recipe, i) => {
              const { image_desktop } = generateRecipeImages(recipe);
              const recipeObj = {
                recipeId: recipe.rezept_id,
                isClickOut:
                  recipe.produkttyp === "Tiptopf" ||
                  (recipe.produkttyp as never) === "",
                title: recipe.rezept_titel,
                difficultyLevel: {
                  level: recipe.schwierigkeitsgrad as 0 | 1 | 2 | 3,
                  label: getLabel(
                    `difficulty_level_${recipe.schwierigkeitsgrad}_label`,
                  ),
                },
                image: image_desktop,
              };
              return (
                <li className="column is-6-tablet is-4-desktop" key={i}>
                  <RecipeCard
                    recipe={recipeObj}
                    htmlTag={3}
                    needsTotalLikeCount={false}
                  />
                </li>
              );
            })}
          </ul>
          {recipesToShow.length < (recipeFav?.rezepte_list?.length || 0) && (
            <Button
              type="primary"
              href="#"
              target={""}
              onClick={handleLoadMore}
              icon={"arrow-circle"}
              aria-label={getLabel("load_more_label")}
              className="mx-auto mt-6"
            >
              {getLabel("load_more_label")}
            </Button>
          )}
        </>
      ) : (
        <></>
      )}
      {loading && <Loader />}
    </Section>
  );
}

export default Favorite;
